import request from "@/plugins/axios";
export default {
  //获取连接器列表
  getConnectorList(params) {
    return request.get(`/Opencloud/Connector/ConnectorList`, params);
  },
  // 新增连接器
  assConnnect(data) {
    return request.put(`/Opencloud/Connector/Connector`, data);
  },
  // 获取连接器详情
  getConnectorInfo(id) {
    return request.get(`/Opencloud/Connector/ConnectorInfo?id=${id}`);
  },
  // 更新连接器
  editConnectorInfo(data) {
    return request.post(`/Opencloud/Connector/Connector`, data);
  },
  // 删除连接器
  deleteConnector(Id) {
    return request.delete(`/Opencloud/Connector/Connector?Id=${Id}`);
  },
  // 获取触发事件列表
  getTriggerEventList(connectorId, pageIndex, pageSize) {
    return request.get(`/Opencloud/Trigger/TriggerList?connectorId=${connectorId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  },
  // 获取触发事件详情 by id
  getTriggerById(id) {
    return request.get(`/Opencloud/Trigger/TriggerInfo?id=${id}`);
  },
  // 新增触发事件
  addTriggerEvent(params) {
    return request.put(`/Opencloud/Trigger/Trigger`, params);
  },
  // 编辑触发事件
  editTriggerEvent(params) {
    return request.post(`/Opencloud/Trigger/Trigger`, params);
  },
  // 删除触发事件
  deleTriggerEvent(id) {
    return request.delete(`/Opencloud/Trigger/Trigger?id=${id}`);
  },
  // 分页获取连接流列表
  getFlowList() {
    return request.get(`/Opencloud/Flow/FlowList`);
  },
  // 获取执行动作列表
  getActionEventList(connectorId, pageIndex, pageSize) {
    return request.get(`/Opencloud/Action/ActionList?connectorId=${connectorId}&pageIndex=${pageIndex}&pageSize=${pageSize}`);
  },
  // 获取执行动作详情 by id
  getActionById(id) {
    return request.get(`/Opencloud/Action/ActionInfo?id=${id}`);
  },
  // 新增执行动作
  addActionEvent(params) {
    return request.put(`/Opencloud/Action/Action`, params);
  },
  // 编辑执行动作
  editActionEvent(params) {
    return request.post(`/Opencloud/Action/Action`, params);
  },
  // 删除执行动作
  deleActionEvent(id) {
    return request.delete(`/Opencloud/Action/Action?id=${id}`);
  },
  // 获取发布的执行动作详情
  getPublishedAction(id) {
    return request.delete(`/api/Opencloud/Action/ActionPublished?id=${id}`);
  },
  // 发布执行动作
  publishAction(id) {
    return request.delete(`/Opencloud/Action/PublishAction?id=${id}`);
  },
};
